module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/4_abbc4a1001497ecf69a99a97877974c7.png";